import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);

export const useChangelogPositionExperiment = createExperimentHook(
  'changelog-position',
  true,
  { alternate: false }
);

export type SearchResultLayoutExperimentType =
  | boolean
  | 'wide'
  | 'without panorama'
  | 'wide and without panorama';

export const useSearchResultLayoutExperiment = createExperimentHook<
  SearchResultLayoutExperimentType
>('search-result-layout', false, {
  wide: 'wide',
  withoutPanorama: 'without panorama',
  wideAndWithoutPanorama: 'wide and without panorama',
});

export type TrailingSkyscraperExperimentType =
  | boolean
  | 'trailing skyscraper'
  | 'trailing and refreshing skyscraper';

export const useTrailingSkyscraperExperiment = createExperimentHook<
  TrailingSkyscraperExperimentType
>('trailing-skyscraper', false, {
  trailingSkyscraper: 'trailing skyscraper',
  trailingAndRefreshingSkyscraper: 'trailing and refreshing skyscraper',
});

export const useSearchUnfeaturedClickout = createExperimentHook(
  'search-unfeatured-clickout',
  true,
  {
    disabled: false,
  }
);

export const useSortByFeaturedExperiment = createExperimentHook(
  'sortby-featured',
  false,
  {
    sortByFeatured: true,
  }
);

export const useNewSearchApiKWLP = createExperimentHook(
  'new-search-index-kwlp',
  false,
  {
    new: true,
  }
);
